import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { FormHelperText, styled, Typography } from "@mui/material";
import { useState,useEffect } from "react";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const StyledHelperText = styled(Typography)(({ theme }) => ({
  fontSize: "11px",
  marginLeft: "12px",
  marginTop: "3px",
  fontFamily: "DM Sans,sans-serif",
  lineHeight: 1.66,
  textAlign: "left",
  color: theme.palette.text.secondary,
  "&.error": {
    color: theme.palette.error.main,
  },
}));

export default function CustomMultiSelect({
  id,
  label,
  isMandatoryField,
  options,
  values,
  onChange,
  disabled = false,
  error = false,
  helperText,
}) {
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
  
    onChange(
      value.map((item) =>
        typeof item === "string"
          ? options.find((option) => option.id === item)
          : item
      )
    );
  };
 useEffect(() => {
    // Filter out any selected values that are no longer valid
    const validValues = values.filter((value) =>
      options.some((option) => option.id === value.id)
    );

    // Update the selected values if they have changed
    if (validValues.length !== values.length) {
      onChange(validValues);
    }
  }, [options, values, onChange]);

  return (
    <>
    <Typography variant="labelSm" color={"text.primary"} component={"label"}>
      {label}
      {isMandatoryField && (
        <Typography component={"span"} color={"error"}>
          *
        </Typography>
      )}
    </Typography>
    <FormControl fullWidth>
      <Select
        disabled={disabled}
        multiple
        error={error}
        value={values.map((val) => val.id)} // Map to IDs for comparison
        onChange={handleChange}
        displayEmpty
        renderValue={(selected) => {
          if (selected?.length === 0) {
            return (
              <Typography color={"#7F7F7F"} sx={{ opacity: 0.5 }}>
                Please Select
              </Typography>
            );
          }
          return selected
            ?.map((id) => options.find((option) => option.id === id)?.label)
            .join(", ");
        }}
        MenuProps={MenuProps}
        input={<OutlinedInput />}
      >
        {options?.length === 0 ? (
          <MenuItem disabled>
            <Typography>No options</Typography>
          </MenuItem>
        ) : (
          options?.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              <Checkbox
                checked={values.some((val) => val.id === option.id)}
              />
              <ListItemText primary={option.label} />
            </MenuItem>
          ))
        )}
      </Select>
      <StyledHelperText fontSize={"11px"} className={error ? "error" : ""}>
        {helperText}
      </StyledHelperText>
    </FormControl>
  </>
  );
}
